import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import TwoFaAuth from '~/pages/Authentication/TwoFaAuth';
import ForceChangePassForm from '~/pages/Authentication/ForceChangePassForm';
import { getRoute } from '~/utils/helpers';
import { CLIMATE_CHECK_SLUG, CO2_LFL_SLUG, FARMER_ROLE_SLUG, tradingSlotModules } from '~/Constants';
import { RouteTypes } from '../constants';

const PublicRoute: React.FunctionComponent = () => {
  const { isAuthenticated, systemData, isTfaRequired, forcePassword } = useAuth();

  const operativeUsersCanSeeFarmersInfo = systemData?.operativeUsersCanSeeFarmersInfo
  const hasAnyTradingSlot = Boolean(systemData?.modules?.find(module => !!tradingSlotModules.find(tradingSlotSlug => tradingSlotSlug === module.slug)))
  const hasCo2Module = Boolean(systemData?.modules?.find(module => module.slug === CO2_LFL_SLUG))
  const hasClimaCheckModule = Boolean(systemData?.modules?.find(module => module.slug === CLIMATE_CHECK_SLUG))
  const userNoFixedPriceNoCoModules = !hasAnyTradingSlot && !hasCo2Module

  const iframeDmkPath = Boolean(systemData?.hideMenuAndHeader) && hasClimaCheckModule
  const farmerWithClimaCheck = systemData?.logged?.roleSlug === FARMER_ROLE_SLUG && hasClimaCheckModule

  const path = iframeDmkPath || farmerWithClimaCheck ?
    RouteTypes.CLIMATE_CHECK :
    getRoute(systemData?.logged?.roleSlug, operativeUsersCanSeeFarmersInfo, userNoFixedPriceNoCoModules)

  if (isTfaRequired) {
    return <TwoFaAuth />
  }

  if (forcePassword) {
    return <ForceChangePassForm />
  }

  return isAuthenticated ? <Navigate to={path} /> : <Outlet />;
};

export default PublicRoute;
